<fieldset>
  <div class="column-100">
      <gmt-input label="Datum podání správní žaloby" required="true">
        <input type="text" pick-a-date [(ngModel)]="data.expropriationAdministrativeAppealDate" [maxToday]="true"/>
      </gmt-input>
  </div>
</fieldset>
